import React from "react";
import ClientsInMinusComponent from "../../components/ClientsInMinus/ClientsInMinus.component";
import IPage from "../../interfaces/page"

const ClientsInMinusPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <ClientsInMinusComponent></ClientsInMinusComponent>;
};

export default ClientsInMinusPage;
